import { AppBar, Box, Stack, Toolbar, Typography } from '@mui/material'
import { useAtom, useSetAtom } from 'jotai'
import {
  mainTabAtom,
  selectedCraftAtom,
  selectedGatheringAtom,
  selectedGatheringAreaAtom,
  selectedGatheringItemAtom,
} from '@/atoms'
import type { CraftType, GatheringType } from '@/types'
import { CraftTabBar } from '@/components/ui/CraftTabBar'
import { GatheringTabBar } from '@/components/ui/GatheringTabBar'
import { SearchInput } from '@/components/ui/SearchInput'
import { useItemSearch } from '@/hooks/useItemSearch'

export function AppHeader() {
  const [selectedCraft, setSelectedCraft] = useAtom(selectedCraftAtom)
  const [selectedGathering, setSelectedGathering] = useAtom(selectedGatheringAtom)
  const [mainTab, setMainTab] = useAtom(mainTabAtom)
  const setSelectedGatheringArea = useSetAtom(selectedGatheringAreaAtom)
  const setSelectedGatheringItem = useSetAtom(selectedGatheringItemAtom)
  const { query, setQuery, inputQuery, setInputQuery, suggestions } = useItemSearch()

  function handleCraftChange(craft: CraftType) {
    setSelectedCraft(craft)
    setMainTab('crafting')
  }

  function handleGatheringChange(gathering: GatheringType) {
    setSelectedGathering(gathering)
    setMainTab('gathering')
    setSelectedGatheringArea(null)
    setSelectedGatheringItem(null)
  }

  return (
    <AppBar
      position="static"
      color="default"
      elevation={1}
      sx={{ gridArea: 'header', borderBottom: '1px solid', borderColor: 'divider' }}
    >
      <Toolbar variant="dense" sx={{ gap: 2, flexWrap: 'wrap', py: 0.5 }}>
        <Box sx={{ flex: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1} mb={0.25}>
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              合成：
            </Typography>
            <CraftTabBar
              selected={mainTab === 'crafting' ? selectedCraft : null}
              onChange={handleCraftChange}
            />
          </Stack>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              採集：
            </Typography>
            <GatheringTabBar
              selected={mainTab === 'gathering' ? selectedGathering : null}
              onChange={handleGatheringChange}
            />
          </Stack>
        </Box>

        <SearchInput
          value={query}
          inputValue={inputQuery}
          onInputChange={setInputQuery}
          onCommit={setQuery}
          suggestions={suggestions}
        />
      </Toolbar>
    </AppBar>
  )
}
